import styles from './SummerAnouncementSection.module.css';
import { TagsGroup } from '@features/landing/shared/ui/components/TagsGroup';
import { AnouncementSection } from '@features/landing/shared/ui/sections/AnouncementSection';
import { RatingRange } from '@features/landing/shared/ui/components/RatingRange';

export function SummerAnouncementSection() {
  return (
    <AnouncementSection
      className={styles.root}
      title={
        <>
          Детские онлайн-турниры с&nbsp;обсчетом рейтинга&nbsp;ФШР<sup>*</sup>
        </>
      }
      tags={
        <>
          <TagsGroup>
            <>Блиц</>
            <>Рапид</>
          </TagsGroup>
          <TagsGroup color="active-faded">
            <>Юноши</>
            <>Девушки</>
          </TagsGroup>
          <div className={styles.tagsForWide}>
            <TagsGroup color="gray">
              <>
                III лига{' '}
                <RatingRange
                  className={styles.ratingRange}
                  from={'1000'}
                  to={'1299'}
                />
              </>
              <>
                II лига{' '}
                <RatingRange
                  className={styles.ratingRange}
                  from={'1300'}
                  to={'1699'}
                />
              </>
              <>
                I лига{' '}
                <RatingRange className={styles.ratingRange} from={'1700+'} />
              </>
            </TagsGroup>
          </div>
          <div className={styles.tagsForNarrow}>
            <TagsGroup color="gray">
              <>
                III лига{' '}
                <RatingRange
                  className={styles.ratingRange}
                  from={'1000'}
                  to={'1299'}
                />
              </>
              <>
                II лига{' '}
                <RatingRange
                  className={styles.ratingRange}
                  from={'1300'}
                  to={'1699'}
                />
              </>
            </TagsGroup>
            <TagsGroup color="gray">
              <>
                I лига{' '}
                <RatingRange className={styles.ratingRange} from={'1700+'} />
              </>
            </TagsGroup>
          </div>
        </>
      }
      panelDisclaimer={
        <>Игроки распределяются по&nbsp;лигам на&nbsp;основе рейтинга ФШР</>
      }
      disclaimer={
        <>
          * Допуск при условии соблюдения требований к&nbsp;участникам{' '}
          <span>(см.&nbsp;правила вида спорта шахматы)</span>
        </>
      }
    />
  );
}
